import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";

Vue.use(Router);

import store from "@/store";

const ifRoleAdmin = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleRoomGrp = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "ROOMGRP",])) {
    next();
    return;
  }
  next("/");
};

const ifRoleRoomCfg = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "ROOMCFG", "ROOMADM"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleTvCfg = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "TVCFG"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleTvAdm = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "TVADM"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleUser = (to, from, next) => {
  if (
    store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN", "USER", "OPERATOR"])
  ) {
    next();
    return;
  }
  next("/");
};

const ifRoleIgpAdm = (to, from, next) => {
  if (
    store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN", "IGPADM", "IGPMGR"])
  ) {
    next();
    return;
  }
  next("/");
};

const ifRoleTvMon = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN", "TVMON"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleTvCmd = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN", "TVCMD0"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleEvtWelc = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["EVTS_WELC", "ADMIN", "SITEADMIN"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleEvtMgr = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["EVTMGR", "ADMIN", "SITEADMIN"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleTvStats = (to, from, next) => {
  if (store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN", "TVSTATS"])) {
    next();
    return;
  }
  next("/");
};

const ifRoleMsgMgr = (to, from, next) => {
  if (
    store.getters["guicms/HASROLE"]([
      "ADMIN",
      "SITEADMIN",
      "MSGMGR",
      "IGPADM",
      "IGPMGR"
    ])
  ) {
    next();
    return;
  }
  next("/");
};

const ifRoleSignage = (to, from, next) => {
  if (
    store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN", "SIGMGR", "SIGADM"])
  ) {
    next();
    return;
  }
  next("/");
};

const ifRoleSigAdm = (to, from, next) => {
  if (
    store.getters["guicms/HASROLE"](["ADMIN", "SITEADMIN", "SIGADM"])
  ) {
    next();
    return;
  }
  next("/");
};

export default new Router({
  // mode: "history",
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  // scrollBehavior(to, from, savedPosition) {
  //   const position = {};
  //
  //   if (savedPosition) {
  //     position.x = savedPosition.x;
  //     position.y = savedPosition.y;
  //   } else {
  //     return new Promise(resolve => {
  //       app.$root.$once("scrollBeforeEnter", () => {
  //         resolve(position);
  //       });
  //     });
  //   }
  // },
  routes: [
    {
      path: "/403",
      component: resolve => {
        require(["@/views/pg403.vue"], resolve);
      }
    },
    {
      path: "/login",
      component: resolve => {
        import(/* webpackChunkName: "IgLogin" */ "@/components/IgLogin.vue");
      }
    },
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/guicms",
      name: "Gui CMS",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "CmsList" */ "@/components/CmsListV3.vue")
    },
    {
      path: "/media",
      name: "Media library",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "MediaMgmt" */ "@/views/MediaMgmt.vue")
    },
    {
      path: "/chpled",
      name: "Channel plan",
      beforeEnter: ifRoleAdmin,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "chpled" */ "@/components/ChplEd.vue")
    },
    {
      path: "/newsbc",
      name: "TVC news broadcasts",
      component: () =>
        import(/* webpackChunkName: "newsbc" */ "@/views/NewsBcList.vue")
    },
    {
      path: "/guimediaplaylists",
      name: "Playlists",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(
          /* webpackChunkName: "guimediaplaylists" */ "@/views/GuiMediaPlaylists.vue"
        )
    },
    {
      path: "/langCfg",
      name: "Language config",
      beforeEnter: ifRoleAdmin,
      component: () =>
        import(/* webpackChunkName: "langCfg" */ "@/components/LangCfg.vue")
    },
    {
      path: "/sitecfg",
      name: "Site config",
      beforeEnter: ifRoleAdmin,
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "sitecfg" */ "@/components/SiteCfg.vue")
    },
    {
      path: "/weatherloc",
      name: "Weather config",
      component: () =>
        import(
          /* webpackChunkName: "sitecfg" */ "@/components/WeatherLocEd.vue"
        )
    },
    {
      path: "/foliomgmt",
      name: "Folio management",
      component: () =>
        import(/* webpackChunkName: "foliomgmt" */ "@/views/IgFolioMgmt.vue")
    },
    {
      path: "/roomgroup-mgmt",
      beforeEnter: ifRoleRoomGrp,
      name: "Room Group Management",
      component: () =>
        import(
          /* webpackChunkName: "foliomgmt" */ "@/components/RoomGroupMgmt.vue"
        )
    },
    {
      path: "/hskp",
      name: "Housekeeping",
      component: () =>
        import(/* webpackChunkName: "hskp" */ "@/views/HskpPg.vue")
    },
    {
      path: "/hskpLog",
      name: "Housekeeping logs",
      component: () =>
        import(/* webpackChunkName: "hskp" */ "@/components/IgHskpLog.vue")
    },
    {
      path: "/hskpMbarLogs",
      name: "Housekeeping minibar logs",
      component: () =>
        import(/* webpackChunkName: "hskp" */ "@/views/HskpMbarLogs.vue")
    },
    {
      path: "/surveys",
      name: "Satisfaction surveys",
      component: () =>
        import(/* webpackChunkName: "sitecfg" */ "@/components/SurveyEd.vue")
    },
    {
      path: "/sitewatch-tvclmgrv2",
      name: "TV Clients Management V2",
      beforeEnter: ifRoleTvCmd,
      component: () =>
        import(
          /* webpackChunkName: "TvClMgrV2" */ "@/components/TvClMgrV2.vue"
        )
    },
    {
      path: "/sitewatch-tvclients",
      name: "TV Clients",
      beforeEnter: ifRoleTvCmd,
      component: () =>
        import(
          /* webpackChunkName: "TvClients" */ "@/components/TVClientDevices.vue"
        )
    },
    {
      path: "/sitewatch-tvcl-overview",
      name: "TV client devices - overview",
      beforeEnter: ifRoleTvMon,
      component: () =>
        import(
          /* webpackChunkName: "TvClients" */ "@/components/TvClientsOverview.vue"
        )
    },
    {
      path: "/sitewatch-tvlist",
      name: "TV client devices - list",
      beforeEnter: ifRoleTvMon,
      component: () =>
        import(
          /* webpackChunkName: "TvClients" */ "@/views/TvDetailedList.vue"
        )
    },
    {
      path: "/tvcl-cfg",
      beforeEnter: ifRoleTvCfg,
      component: () =>
        import(
          /* webpackChunkName: "TvClients" */ "@/components/TvClientCfg.vue"
        )
    },
    {
      path: "/room-cfg",
      beforeEnter: ifRoleRoomCfg,
      component: () =>
        import(/* webpackChunkName: "TvClients" */ "@/components/RoomCfg.vue")
    },
    {
      path: "/sitewatch",
      name: "Site-watch",
      // beforeEnter: ifRoleUser,
      component: () =>
        import(/* webpackChunkName: "sitewatch" */ "@/views/SiteWatch.vue"),
      children: [
        {
          path: "chplwatch",
          name: "Channel watch",
          // beforeEnter: ifRoleUser,
          component: () =>
            import(
              /* webpackChunkName: "ChplWatch" */ "@/components/ChplWatch.vue"
            )
        },
        {
          path: "netmon",
          name: "Network monitor",
          beforeEnter: ifRoleUser,
          component: () =>
            import(
              /* webpackChunkName: "NetmonWatch" */ "@/components/NetmonWatch.vue"
            )
        }
      ]
    },
    {
      path: "/guestmsgs",
      name: "Guest msg. management",
      beforeEnter: ifRoleMsgMgr,
      component: () =>
        import(
          /* webpackChunkName: "GuestMsgMgr" */ "@/components/GuestMsgMgr.vue"
        )
    },
    {
      path: "/guestmsgs/chat/:reservationId",
      props: true,
      beforeEnter: ifRoleMsgMgr,
      name: "Guest chat",
      component: () =>
        import(
          /* webpackChunkName: "GuestChat" */ "@/components/GuestChatSession.vue"
        )
    },
    {
      path: "/guestmsgs/chatMgr",
      props: true,
      beforeEnter: ifRoleMsgMgr,
      name: "Guest chat management",
      component: () =>
        import(
          /* webpackChunkName: "GuestChatMgr" */ "@/components/GuestChatMgr.vue"
        )
    },
    {
      path: "/shopcfg",
      name: "Shop config",
      beforeEnter: ifRoleIgpAdm,
      component: () =>
        import(
          /* webpackChunkName: "ShopConfig" */ "@/components/ShopConfig.vue"
        )
    },
    {
      path: "/gpCfg",
      name: "Guest portal config",
      beforeEnter: ifRoleIgpAdm,
      component: () =>
        import(/* webpackChunkName: "GpCfg" */ "@/components/GpCfg.vue")
    },
    {
      path: "/shopmgr",
      name: "Shop management",
      beforeEnter: ifRoleIgpAdm,
      component: () =>
        import(/* webpackChunkName: "ShopCtg" */ "@/views/ShopMgr.vue")
    },
    {
      path: "/shopmgr/ctg/:id",
      props: true,
      beforeEnter: ifRoleIgpAdm,
      name: "Shop category",
      component: () =>
        import(/* webpackChunkName: "ShopCtg" */ "@/components/ShopCtgEd.vue")
    },
    {
      path: "/shopmgr/itm/:id",
      props: true,
      beforeEnter: ifRoleIgpAdm,
      name: "Shop item",
      component: () =>
        import(/* webpackChunkName: "ShopCtg" */ "@/components/ShopItm.vue")
    },
    {
      path: "/cso",
      name: "Order management",
      beforeEnter: ifRoleIgpAdm,
      component: () =>
        import(/* webpackChunkName: "cso1" */ "@/components/ShopOrderMgr.vue")
    },
    {
      path: "/sitewatch-tvcw-stats",
      name: "TVC watch stats",
      beforeEnter: ifRoleTvStats,
      component: () =>
        import(/* webpackChunkName: "TvcwStats" */ "@/views/TvcwStats.vue")
    },
    {
      path: "/htvcast-mgr",
      name: "HTV CAST",
      beforeEnter: ifRoleAdmin,
      component: () =>
        import(/* webpackChunkName: "HtvCastMgr" */ "@/views/HtvCastMgr.vue")
    },
    {
      path: "/tpl-mgmt",
      name: "TPL mgmt",
      beforeEnter: ifRoleSignage,
      component: () =>
        import(
          /* webpackChunkName: "TplMgmt" */ "@/views/TplMgmt.vue"
        )
    },
    {
      path: "/conference-planner",
      name: "Conference planner",
      beforeEnter: ifRoleSignage,
      component: () =>
        import(
          /* webpackChunkName: "SignagePlanner" */ "@/views/ConferencePlanner.vue"
        )
    },
    {
      path: "/conference-cfg",
      name: "Conference module config",
      beforeEnter: ifRoleSignage,
      component: () =>
        import(
          /* webpackChunkName: "ConferenceModCfg" */ "@/views/ConferenceModCfg.vue"
        )
    },
    {
      path: "/signage-planner",
      name: "Signage planner",
      beforeEnter: ifRoleSignage,
      component: () =>
        import(
          /* webpackChunkName: "SignagePlanner" */ "@/views/SignagePlanner.vue"
        )
    },
    {
      path: "/evtwelc-planner",
      name: "Custom welcome planner",
      beforeEnter: ifRoleEvtWelc,
      component: () =>
        import(
          /* webpackChunkName: "SignagePlanner" */ "@/views/EvtWelcPlanner.vue"
        )
    },
    {
      path: "/signage-adm",
      name: "Signage player management",
      beforeEnter: ifRoleSignage,
      component: () =>
        import(
          /* webpackChunkName: "SignagePlanner" */ "@/views/SignagePlrAdm.vue"
        )
    },
    // {
    //   path: "/tvclones-adm",
    //   name: "TvAdmUploader",
    //   beforeEnter: ifRoleAdmin,
    //   component: () =>
    //     import(
    //       /* webpackChunkName: "CloneMgmt" */ "@/components/SiteClonesCfg.vue"
    //     )
    // },
    {
      path: "/tvphl-devmgr",
      name: "TvPhlDevMgr",
      beforeEnter: ifRoleAdmin,
      component: () =>
        import(
          /* webpackChunkName: "TvPhlDevMgr" */ "@/views/TvPhlDevMgr.vue"
        )
    },
    {
      path: "/tvphl-clones",
      name: "TvPhlClones",
      beforeEnter: ifRoleAdmin,
      component: () =>
        import(
          /* webpackChunkName: "TvPhlClones" */ "@/views/TvPhlClones.vue"
        )
    }
  ]
});
